var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { state as initialState } from './index';
import { cloneDeep } from 'lodash';
export var mutations = {
    setForms: function (state, forms) { return state.forms = forms; },
    setSearch: function (state, query) { return state.searchQuery = query; },
    setLoading: function (state, loading) { return state.loading = loading; },
    setPagination: function (state, pagination) { return state.pagination = __assign({}, pagination); },
    setPaginationResponse: function (state, paginationResponse) { return state.paginationResponse = paginationResponse; },
    setFilteredForms: function (state, filtered) { return state.formCounts = __assign(__assign({}, state.formCounts), { filtered: filtered }); },
    setTotalForms: function (state, total) { return state.formCounts = __assign(__assign({}, state.formCounts), { total: total }); },
    setError: function (state, error) { return state.error = error; },
    reset: function (state) { return Object.assign(state, cloneDeep(initialState)); },
};
export var mutationTypes = {
    SET_FORMS: 'setForms',
    SET_FILTERED_FORM_COUNT: 'setFilteredForms',
    SET_TOTAL_FORM_COUNT: 'setTotalForms',
    SET_PAGINATION_RESPONSE: 'setPaginationResponse',
    SET_LOADING_FORMS: 'setLoading',
    SET_ERROR: 'setError',
};
